module.exports = __webpack_public_path__ + "static/media/nazir.d85cf63e.png";